import {
    File,
    Folder,
    FolderOpen,
    FileCode,
    FileJson,
    Image,
    FileType,
    Settings
} from 'lucide-react'
import { MDFileIcon } from './AgentFileEditor/MDFileIcon'

interface FileIconProps {
    name: string
    isFolder?: boolean
    isOpen?: boolean
    className?: string
    size?: number
}

export function FileIcon({ name, isFolder, isOpen, className = '', size = 16 }: FileIconProps) {
    // Get file extension
    const extension = name.split('.').pop()?.toLowerCase()

    // Folder icons
    if (isFolder) {
        return isOpen ? (
            <FolderOpen size={size} className={`text-blue-400 ${className}`} />
        ) : (
            <Folder size={size} className={`text-blue-400 ${className}`} />
        )
    }

    // File type specific icons
    switch (extension) {
        case 'md':
        case 'markdown':
            return <MDFileIcon size={size} className={className} />

        case 'json':
            return <FileJson size={size} className={`text-yellow-400 ${className}`} />

        case 'js':
        case 'jsx':
        case 'ts':
        case 'tsx':
            return <FileCode size={size} className={`text-yellow-300 ${className}`} />

        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'svg':
        case 'webp':
            return <Image size={size} className={`text-purple-400 ${className}`} />

        case 'txt':
            return <FileType size={size} className={`text-gray-400 ${className}`} />

        case 'config':
        case 'conf':
        case 'yaml':
        case 'yml':
        case 'toml':
            return <Settings size={size} className={`text-gray-400 ${className}`} />

        default:
            return <File size={size} className={`text-gray-400 ${className}`} />
    }
}
